import CorePeopleHero from './CorePeopleHero';

export { type CorePeopleHeroProps } from './CorePeopleHero';
export default CorePeopleHero;
